module.exports = __webpack_public_path__ + "static/spot-e1c75bd2e6b9e65a94a87c0f5ca3981a.gif";